import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { MessageTemplate } from 'components/Templates'

const Message: FC = () => {
  return (
    <Layout headline={'メッセージ配信'} iconPath={'/icon/white/message.svg'} title={'メッセージ配信'}>
      <MessageTemplate />
    </Layout>
  )
}

export default Message
